/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AffectedQuoteDto } from './AffectedQuoteDto';
import {
    AffectedQuoteDtoFromJSON,
    AffectedQuoteDtoFromJSONTyped,
    AffectedQuoteDtoToJSON,
    AffectedQuoteDtoToJSONTyped,
} from './AffectedQuoteDto';

/**
 * Response containing a list of quotes affected by entity modifications
 * @export
 * @interface AffectedQuotesResponse
 */
export interface AffectedQuotesResponse {
    /**
     * Total number of affected quotes
     * @type {number}
     * @memberof AffectedQuotesResponse
     */
    count?: number;
    /**
     * List of affected quotes with minimal information
     * @type {Array<AffectedQuoteDto>}
     * @memberof AffectedQuotesResponse
     */
    quotes?: Array<AffectedQuoteDto>;
}

/**
 * Check if a given object implements the AffectedQuotesResponse interface.
 */
export function instanceOfAffectedQuotesResponse(value: object): value is AffectedQuotesResponse {
    return true;
}

export function AffectedQuotesResponseFromJSON(json: any): AffectedQuotesResponse {
    return AffectedQuotesResponseFromJSONTyped(json, false);
}

export function AffectedQuotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffectedQuotesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'quotes': json['quotes'] == null ? undefined : ((json['quotes'] as Array<any>).map(AffectedQuoteDtoFromJSON)),
    };
}

export function AffectedQuotesResponseToJSON(json: any): AffectedQuotesResponse {
    return AffectedQuotesResponseToJSONTyped(json, false);
}

export function AffectedQuotesResponseToJSONTyped(value?: AffectedQuotesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'quotes': value['quotes'] == null ? undefined : ((value['quotes'] as Array<any>).map(AffectedQuoteDtoToJSON)),
    };
}

